import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import "rxjs/Rx";
import { Subject }    from 'rxjs/Subject';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from "../auth.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

import { SharedModule, NumPipe, UtilsService } from "../shared/shared.module";
import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'app-list-order',
  templateUrl: './list-order.component.html',
  styleUrls: ['./list-order.component.css']
})
export class ListOrderComponent implements OnInit {

  page: number = 1;
  totalPage: number = 1;
  search: string = "";
  limit: number = 10;
  sortBy: any = ['id'];
  revert: boolean = false;
  txtQueryChanged: Subject<string> = new Subject<string>();
  isLoading: boolean = false;

  errors = {};
  orders:any = null;

  possibleStatus: any = [
    {value: '', text: 'Toutes les commandes'},
    {value: 'TO_PREPARE', text: 'Commandes à préparer'},
    {value: 'PREPARED', text: 'Commandes préparées'},
    {value: 'REFUSED', text: 'Commandes refusées'}
  ];

  selectedStatus: string = '';

  constructor(
    private numPipe: NumPipe,
    public authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsService
  ) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      else
        this.utilsService.scrollTop();
    });

    this.authService.getSession();

    this.txtQueryChanged
	  .debounceTime(500) // wait x sec after the last event before emitting last event
	  .distinctUntilChanged() // only emit if value is different from previous value
	  .subscribe(model => {
      this.search = model;
      this.page = 1;
      this.getOrders();
    });
    this.getOrders();
  }

  getOrders(resetPage = false) {
    this.isLoading = true;
    this.errors = {};

    if (resetPage == true)
      this.page = 1;

		var query = "?search=" + this.search + "&limit=" + this.limit + "&page=" + this.page + "&sortBy=" + this.sortBy + "&revert=" + this.revert + '&status=' + this.selectedStatus;
		if (this.authService.connectedAs.admin == false)
      query += "&connectedAsId=" + this.authService.connectedAs.id;

		this.http.get(environment.API_PATH + '/product/order' + query, {withCredentials: true})
		.subscribe(
      data => {
        this.isLoading = false;
        this.orders = data['rows'];
        this.totalPage = Math.ceil(data['count'] / this.limit) ;
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  changePage(num: number, n:number = null): void {
    if (n)
      this.page = this.numPipe.transform(num, n);
    else
      this.page = num;

    this.getOrders();
  };

  sortTable(sortBy: string): void {
    if (this.sortBy === sortBy)
      this.revert = !this.revert;
    else
      this.revert = false;
    this.sortBy = sortBy;
    this.getOrders();
  }

  seeOrderDetail(order) {
    this.router.navigate(['detail', order.id], {relativeTo: this.route});
  }

  onSearchChange(query:string) {
    this.txtQueryChanged.next(query);
  }

}



// WEBPACK FOOTER //
// ./src/app/list-order/list-order.component.ts